import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class InvoicesToForcedPendingSync {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(inv_ids): Promise<any> {
    let args = { 
        inv_ids: inv_ids,
    }
    return await this.dispatcher.dispatch('invoices.to.forced.pending.sync', args)
  }
}